import React from 'react'
import StatisticsAddBasketPage from './StatisticsAddBasketPage'
import '../styles/index.scss'

function StatisticsAddBasketContainer() {
    return (
        <div className='StatisticsAddBasketContainer'>
            <StatisticsAddBasketPage />
        </div>
    )
}

export default StatisticsAddBasketContainer